import { WSAlert } from "@wingspanhq/fe-component-library";
import { FormType } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { queriesForms } from "@query";
import { TAX_DOCUMENTS_PATH } from "../../TaxDocuments/paths";
import { useCurrentTaxDocumentsYear } from "../../TaxDocuments/utils/useCurrentTaxDocumentsYear";

export const BannerT4ATaxForm: React.FC = () => {
  const history = useHistory();
  const currentYear = useCurrentTaxDocumentsYear();

  const queryT4AForms = queriesForms.listForms.useQuery({
    filter: {
      type: { eq: FormType.T4_A },
      year: { eq: Number(currentYear) }
    }
  });

  if (!queryT4AForms.data?.data?.length) {
    return null;
  }

  return (
    <WSAlert
      title="Tax documents"
      theme="info"
      icon="info-circle"
      action={{
        text: "View tax documents",
        onClick: () => {
          history.push(TAX_DOCUMENTS_PATH);
        }
      }}
    >
      Your tax documents dashboard has been updated. Review your T4A form to
      ensure all reported information is accurate.
    </WSAlert>
  );
};
